const MFG_MODEL_DEACTIVATE_ROLES = [
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

const MFG_MODEL_PERMANENT_DELETE_ROLES = [
  "owner",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

/** Client-side gate for manufacturing model deactivation (soft delete / archive). */
export function canDeactivateManufacturingModel(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  return hasRole(...MFG_MODEL_DEACTIVATE_ROLES);
}

/** Permanent delete — org owner or platform only (not mere admin / org_admin). */
export function canPermanentlyDeleteManufacturingModel(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  return hasRole(...MFG_MODEL_PERMANENT_DELETE_ROLES);
}

/** Material / recipe catalog code renames (admin or owner only). */
export const canEditManufacturingCatalogCode = canDeactivateManufacturingModel;

/** Permanent material delete (inactive duplicates) — same admin/owner gate. */
export const canPermanentlyDeleteManufacturingMaterial = canDeactivateManufacturingModel;

/** Hard-delete a Part use when no recipes reference it — same admin/owner gate. */
export const canDeleteManufacturingMaterialUse = canDeactivateManufacturingModel;
